<template>
  <div class="semi-progress" style="width:65px;height:65px">
    <!-- 底部半圆背景 -->
    <div class="progress-bg" :style="{ backgroundColor: bgColor, borderColor: borderColor }">
      <!-- 进度半圆 -->
      <div class="progress-bar"></div>
      <!-- 底部波浪装饰 -->
      <div class="wave" :style="{ backgroundColor: waveColor, height: percent + '%' }"></div>
    </div>
    <!-- 中间百分比文字 -->
    <div class="progress-text">{{ percent }}%</div>
  </div>
</template>

<script>
export default {
  name: "SemiCircleProgress",
  props: {
    // 百分比 0-100
    percent: {
      type: Number,
      default: 0
    },
    // 状态：'gray' | 'red' | 'green'
    status: {
      type: String,
      default: "1"
    }
  },
  computed: {
    // 状态映射颜色
    colorMap() {
      return {
        0: { bg: "#25b175", border: "#25b175", wave: "#25b175" },
        1: { bg: "#f21010", border: "#f21010", wave: "#f21010" },
        2: { bg: "#c8c7c7", border: "#c8c7c7", wave: "#c8c7c7" },
        3: { bg: "#fba078", border: "#fba078", wave: "#fba078" },
        4: { bg: "#4788f6", border: "#4788f6", wave: "#4788f6" }
      };
    },
    bgColor() {
      return this.colorMap[this.status].bg;
    },
    borderColor() {
      return this.colorMap[this.status].border;
    },
    waveColor() {
      return this.colorMap[this.status].wave;
    }
  }
};
</script>

<style scoped>
.semi-progress {
  position: relative;
  overflow: hidden;
  border-radius: 50%; /* 半圆 */
}

.progress-bg {
  width: 100%;
  height: 100%;
  border: 2px solid;
  border-radius: inherit;
  position: relative;
  overflow: hidden;
}

.progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
}

.wave {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 20%;
}

.progress-text {
  width: 100%;
  position: absolute;
  top: 40%;
  left: 50%;
  color: #fff;
  text-align: center;
  transform: translate(-50%, -50%);
  font-size: 18px;
  font-weight: bold;
  text-shadow: 1px 1px 4px #000;
}
</style>
